import { useAppSelector } from "@/hooks/redux";

import { QueueTaskStatus } from "../core/useAsyncTaskQueue";

export const useQueueInfo = () => {
    const requestQueue = useAppSelector((s) => s.offline.requestQueue);
    const requestQueueStatus = useAppSelector(
        (s) => s.offline.requestQueueStatus,
    );

    const requestQueueLength = requestQueue.filter(
        (q) => q.status !== QueueTaskStatus.Error,
    ).length;

    const hasPending = requestQueueLength > 0;

    return {
        hasPending,
        isRunning: requestQueueStatus.isRunning,
        requestQueue,
    };
};
